module.exports = __webpack_public_path__ + "static/media/YF01_0.eb766bff.jpg";